import Icon, { icons } from '../generic/Icon';
import styles from './ApplicationMobileWarning.module.less';

/**
 * Warning message which overlays the entire app if viewport width is too small.
 * Informs the user that the app should be used on Desktop
 */
const ApplicationMobileWarning = () => (
  <div className={styles.mobileWarning}>
    <div className={styles.mobileWarningContents}>
      <span className={styles.mobileWarningContentsIcon}>
        <Icon icon={icons.remove} />
      </span>
      <h2>
        Use on Desktop
      </h2>
      <p>
        FOSSA does not currently support this screen size!
      </p>
    </div>
  </div>
);

export default ApplicationMobileWarning;
